<template>
  <div v-if="exportConfig.csvExport || exportConfig.pngExport">
    <button
      type="button"
      aria-label="Export"
      class="ml-2 download-chip-activator"
      :disabled="disabled"
      @click="showModal = true"
    >
      <v-icon
        icon="$tray-arrow-down"
        :size="18"
        :color="useLighterColor ? 'iconDark' : 'iconDarkest'"
      />
    </button>
    <Modal
      :show="showModal"
      hide-default-actions
      width="380px"
      @close="showModal = false; toggledToPngExport = true;"
    >
      <template #title>
        <h5>Download Report</h5>
      </template>
      <template #content>
        <DpplSwitch
          v-if="exportConfig.pngExport && exportConfig.csvExport"
          left="Image"
          right="CSV"
          :value="isPngExport"
          :width="320"
          new-version
          class="mb-4 slim-switch"
          @change="toggledToPngExport = !toggledToPngExport"
        />
        <PNGDownload
          v-if="isPngExport"
          :export-config="exportConfig"
          @close="showModal = false"
        />
        <component
          :is="csvDownloadComponent"
          v-else-if="!isPngExport && csvDownloadComponent"
          :export-config="exportConfig"
          @close="showModal = false"
        />
      </template>
    </Modal>
  </div>
</template>

<script setup>
import Modal from '@/components/shared/Modal.vue';
import { ref, computed } from 'vue';
import DpplSwitch from '@/components/datapeople/DpplSwitch.vue';
import SingleCSVOption from '@/components/insights/ExportModal/SingleCSVOption.vue';
import MultipleCSVOptions from '@/components/insights/ExportModal/MultipleCSVOptions.vue';
import ReqReportCSVOptions from '@/components/insights/ExportModal/ReqReportCSVOptions.vue';
import PNGDownload from '@/components/insights/ExportModal/PNGDownload.vue';
import { storeToRefs } from 'pinia';
import { useInsightsExport } from '@/stores/insights/export';

const { exportConfig } = storeToRefs(useInsightsExport());

const showModal = ref(false);
const toggledToPngExport = ref(true);

defineProps({
  disabled: { type: Boolean, default: false },
  useLighterColor: { type: Boolean, default: false },
});

const csvDownloadComponent = computed(() => {
  const csvLength = exportConfig.value?.csvOptions?.length || 0;
  const { isReqReport } = exportConfig.value || {};

  if (isReqReport) return ReqReportCSVOptions;
  if (csvLength === 1) {
    return SingleCSVOption;
  } if (csvLength > 1) {
    return MultipleCSVOptions;
  }

  return null;
});

const isPngExport = computed(() => toggledToPngExport.value && exportConfig.value?.pngExport);
</script>

<style scoped lang="less">
.download-chip-activator {
  width: 40px;
  height: 40px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background: @bg-default;
  border: 1px solid @stroke-default;
  border-radius: 8px;

  :deep(.v-chip__overlay) {
    display: none;
  }

  &:hover, &[aria-expanded="true"] {
    background: @bg-brand-default !important;

    :deep(path) {
      fill: @white;
    }
  }
}

.slim-switch {
  height: 36px !important;
  border: 1px solid @stroke-default;

  :deep(.button-background-container) {
    padding: 4px !important;
  }

  :deep(.p2) {
    font-size: 12px !important;

    &.button-background {
      height: 28px !important;
    }
  }
}
</style>
